import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { AdjustableComponent, CLOTH_RAIL_ALIGN_SERIES_LEFT, CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY } from '@inter-ikea-storageone/range';
/**
 * Get the cloth rails that are on the outside right side of the frame
 * @param frame The frame entity
 * @returns Array of cloth rail entities that are are on the outside right side of the frame
 */
export const getOutsideClothRails = (coreApi, frame) => {
    const clothRailEntities = HierarchyUtils.children(frame).filter(entity => entity.hasComponent(AdjustableComponent.id));
    const outsideClothRailEntities = clothRailEntities.filter(clothRailEntity => {
        const outsideClothRail = clothRailEntity
            .getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
            ?.connections.find(c => c.hostConnector.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY));
        return outsideClothRail !== undefined;
    });
    return outsideClothRailEntities;
};
/**
 * Evaluate if selected entity has outside cloth rail on top. Left or right.
 * @param coreApi CoreApi instance
 * @param selectedEntity The selected entity
 * @returns true if selected entity has outside cloth rail on top, false otherwise
 */
export const hasOutsideClothRailOnTop = (coreApi, selectedEntity) => {
    const topMountingPosition = getTopMountingPosition(coreApi, selectedEntity);
    const clothRailOnTopLeftSide = hasClothRailOnTopLeftSide(selectedEntity, topMountingPosition);
    const clothRailOnTopRightSide = hasClothRailOnTopRightSide(coreApi, selectedEntity, topMountingPosition);
    return clothRailOnTopLeftSide || clothRailOnTopRightSide;
};
const getTopMountingPosition = (coreApi, selectedEntity) => {
    const connectorCount = (selectedEntity
        .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
        ?.connectors.find(c => c.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY.substring(0, CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY.length - 2)))).subConnectorCount - 1;
    return connectorCount.toString();
};
const hasClothRailOnTopRightSide = (coreApi, selectedEntity, topMountingPosition) => {
    const outsideClothRailsRightSide = getOutsideClothRails(coreApi, selectedEntity);
    for (let i = 0; i < outsideClothRailsRightSide.length; i++) {
        const mountingPosition = getClothRailHostMountingPosition(outsideClothRailsRightSide[i]);
        if (mountingPosition === topMountingPosition) {
            return true;
        }
    }
    return false;
};
const hasClothRailOnTopLeftSide = (selectedEntity, topMountingPosition) => {
    const clothRailOnLeftSide = selectedEntity
        .getComponent(ComponentIds.ALIGNMENT_CONNECTIONS_COMPONENT_ID)
        ?.connections.filter(c => c.demandingConnector.key.includes(CLOTH_RAIL_ALIGN_SERIES_LEFT));
    const anyConnectorKeyIncludesTopPosition = clothRailOnLeftSide?.some(c => c.demandingConnector.key.includes(topMountingPosition));
    return anyConnectorKeyIncludesTopPosition || false;
};
/**
 * Get the mounting position of the cloth rail
 * @param clothRail A cloth rail entity
 * @returns a string with the mounting position or empty string if not found
 */
export const getClothRailHostMountingPosition = (clothRail) => {
    return (clothRail
        .getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
        ?.connections.find(c => c.hostConnector.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY))
        ?.hostConnector.key.split('-')
        .pop() || '');
};
//# sourceMappingURL=clothRailUtils.js.map